<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="Modules.FINANZAS" :profile-id="Profiles.PERSONAL" reference="cashDetail" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
              <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="list-view-icon-btn list-view-icon-btn--primary" :disabled="!filters.finances_cash" v-b-tooltip.hover.bottom title="Movimientos de caja" aria-label="Movimientos de caja">
                <template #button-content><AppIcon name="add" /></template>
                <b-dropdown-item @click="goTo('positive-adjustment')"><span class="cash-detail-movement-item"><span class="cash-detail-movement-icon cash-detail-movement-icon--positive"><AppIcon name="add" /></span> Ajuste positivo</span></b-dropdown-item>
                <b-dropdown-item @click="goTo('negative-adjustment')"><span class="cash-detail-movement-item"><span class="cash-detail-movement-icon cash-detail-movement-icon--negative"><AppIcon name="remove" /></span> Ajuste negativo</span></b-dropdown-item>
                <b-dropdown-item @click="goTo('transfer')"><span class="cash-detail-movement-item"><span class="cash-detail-movement-icon cash-detail-movement-icon--transfer"><AppIcon name="swap_horiz" /></span> Transferir</span></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters" :key="keyForceUpdate">
            <div class="list-view-filter cash-detail-filter-findobject cash-detail-filter-cash"><FindObject render="search" type="cash" @select-object="loadCash($event)" :orWhere="conditionCashOr" :showAllRegister="true" :valueID="filters.finances_cash_id" /></div>
            <div class="list-view-filter"><label class="filter-label">Desde</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter"><label class="filter-label">Hora desde</label><b-form-timepicker size="sm" now-button reset-button v-model="filters.time_start" locale="es" /></div>
            <div class="list-view-filter"><label class="filter-label">Hasta</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <div class="list-view-filter"><label class="filter-label">Hora hasta</label><b-form-timepicker size="sm" now-button reset-button v-model="filters.time_end" locale="es" /></div>
            <div class="list-view-filter cash-detail-filter-findobject cash-detail-filter-currency"><FindObject render="search" type="currency" auto-select-single @select-object="loadCurrency($event)" :valueID="filters.currency_id" :where="conditionCurrencyActive" /></div>
            <div class="list-view-filter cash-detail-filter-findobject cash-detail-filter-staff"><FindObject render="search" type="staff" tag="Usuario" @select-object="loadStaffFilter($event)" :valueID="filters.staff_id" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterReport" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>
      
      <b-card no-body class="cash-detail-movimientos" v-if="filters.finances_cash">
            <div class="cash-detail-context" v-if="filters.finances_cash.only_open">
              <div class="cash-detail-context__status">
                <span v-if="filters.finances_cash.opening" class="table-cash-status-open"><AppIcon name="lock_open" /> Caja abierta <small>(<span v-html="statusCash(filters.finances_cash)"></span>)</small></span>
                <span v-else class="table-cash-status-close"><AppIcon name="lock" /> Caja cerrada</span>
                <b-button @click="searchCash" type="button" variant="link" size="sm" class="list-view-ghost-btn cash-detail-context__refresh" v-b-tooltip.hover title="Actualizar estado y movimientos"><AppIcon name="refresh" class="mr-1" /> Actualizar</b-button>
              </div>
            </div>
            <div class="cash-detail-purchase-bar" v-if="selectedMovements.length">
              <span><b>{{ selectedMovements.length }}</b> {{ selectedMovements.length == 1 ? 'movimiento seleccionado' : 'movimientos seleccionados' }} · {{ selectedTotalFormat }}</span>
              <div>
                <b-button size="sm" variant="outline-secondary" class="mr-1" @click="selectedMovements = []">Limpiar</b-button>
                <b-button size="sm" variant="dark" @click="loadPurchase()"><AppIcon name="receipt_long" class="mr-1" /> Cargar comprobante</b-button>
              </div>
            </div>
            <b-table class="app-table m-0 p-0"
                    responsive
                    sticky-header="60vh"
                    :hover="true"
                    :stacked="isMobileViewport ? 'md' : false"
                    :fixed="!isMobileViewport"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :items="table.items"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(id)="data">
                <b-form-checkbox v-if="purchasePending(data.item)" class="d-inline-block"
                                 v-model="selectedMovements" :value="data.item.id"
                                 v-b-tooltip.hover title="Incluir en el comprobante" />
                {{ data.item.id }}
              </template>

              <template v-slot:cell(date)="data">
                <div v-if="data.item.date_time">
                  {{ moment(data.item.date_time).format('DD MMMM YYYY') }}
                </div>
              </template>

              <template v-slot:cell(time)="data">
                <div v-if="data.item.date_time">
                  {{ moment(data.item.date_time).format('HH:mm') }}
                </div>
              </template>

              <template v-slot:cell(origen)="data">
                <span v-if="data.item.origen.customer"><b>CLIENTE:</b> {{data.item.origen.customer}}</span>
                <span v-if="data.item.origen.supplier"><b>PROVEEDOR:</b> {{data.item.origen.supplier}}</span>
              </template>

              <template v-slot:cell(staff)="data">
                <span v-if="data.item.origen.staff" class="d-flex align-items-center"
                      v-b-tooltip.hover :title="'Usuario: ' + data.item.origen.staff">
                  <b-avatar v-if="data.item.origen.staff_image" :src="data.item.origen.staff_image" size="25px" />
                  <b-avatar v-else size="25px"
                            :text="avatarFromName(data.item.origen.staff).text"
                            :style="avatarFromName(data.item.origen.staff).style" />
                  <span class="ml-2">{{ data.item.origen.staff }}</span>
                </span>
                <span v-else class="text-muted">—</span>
              </template>

              <template v-slot:cell(observations)="data">
                <span v-if="data.item.origen.observations" class="cash-detail-origin-observations">{{ data.item.origen.observations }}</span>
              </template>

              <template v-slot:cell(reference)="data">                                                                                
                <div v-if="!Array.isArray(data.item.origen)" style="cursor: pointer;" v-b-tooltip.hover.bottom :title="data.item.reference">
                  <div v-if="data.item.origen.customer">                      
                    <div :id="'customer-extra-'+data.item.id">                    
                      {{data.item.reference}}
                    </div>
                    <b-popover :target="'customer-extra-'+data.item.id" triggers="hover" placement="top">
                      <template #title>Datos de Recibo</template>

                      <span v-if="data.item.origen.point_sale">
                        {{data.item.origen.types_vouchers}} <br>
                        {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                        <hr>
                        {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                        ({{data.item.origen.customer_id}}) - {{data.item.origen.customer}} 
                        <hr>
                        {{ data.item.origen.observations }}                      
                      </span>
                    </b-popover>                                      
                  </div>
                  
                  <div v-if="data.item.origen.supplier">
                    <div :id="'supplier-extra-'+data.item.id">                    
                      {{data.item.reference}}
                    </div>
                    <b-popover :target="'supplier-extra-'+data.item.id" triggers="hover" placement="top">
                      <template #title>Datos de Pago</template>                    

                      <span v-if="data.item.origen.point_sale">
                        {{data.item.origen.types_vouchers}} <br>
                        {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                        <hr>
                        {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                        ({{data.item.origen.supplier_id}}) - {{data.item.origen.supplier}} 
                        <hr>
                        {{ data.item.origen.observations }}
                      </span>
                    </b-popover> 
                  </div>                  
                  <div v-if="!data.item.origen.customer && !data.item.origen.supplier">
                    {{data.item.reference}}
                  </div>
                </div>    
                <div v-else v-b-tooltip.hover.bottom :title="data.item.reference">
                  {{data.item.reference}}
                </div>
                <!-- tipo de movimiento bancario y estado del comprobante de compra -->
                <div class="mt-1" v-if="isBankCash && (data.item.bank_type || data.item.purchase_link)">
                  <span class="cash-detail-purchase cash-detail-purchase--type" v-if="data.item.bank_type">{{ bankTypeName(data.item.bank_type) }}</span>
                  <template v-if="data.item.purchase_link">
                    <span v-if="data.item.purchase_link.status == 'PENDING'" class="cash-detail-purchase cash-detail-purchase--pending ml-1"
                          v-b-tooltip.hover title="Tildá este movimiento (y los que van con él) para cargar el comprobante.">
                      <AppIcon name="warning" /> Falta comprobante
                    </span>
                    <span v-else class="cash-detail-purchase cash-detail-purchase--linked ml-1">
                      <AppIcon name="receipt_long" /> {{ data.item.purchase_link.reference }}
                    </span>
                  </template>
                </div>
              </template>

              <template v-slot:cell(amount)="data">
                <span v-if="data.item.type_balance=='+'" class="cash-detail-text-success">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount)}}
                </span>
                <span v-if="data.item.type_balance=='-'" class="cash-detail-text-danger">
                  ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount)}})
                </span>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'cash-detail-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }" v-if="data.item.manual || canSetBankType(data.item)">
                  <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                  <b-dropdown-header v-if="data.item.accounting_lock" :title="data.item.accounting_lock">Bloqueado por Contabilidad</b-dropdown-header>
                  <b-dropdown-item @click="openBankType(data.item)" v-if="canSetBankType(data.item) && !data.item.accounting_lock">
                    <AppIcon name="label" class="mr-1" /> Definir tipo de movimiento
                  </b-dropdown-item>
                  <b-dropdown-item @click="remove(data.item)" v-if="data.item.manual && !data.item.accounting_lock">
                    <AppIcon name="delete" class="mr-1" /> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <EmptyState v-else icon="receipt_long" title="No se encontraron movimientos" />
            <div class="app-table-footer cash-detail-table-footer" v-if="table.items.length">
              <span>{{ table.tablePaginate ? table.tablePaginate.total : table.items.length }} registros</span>
              <export-excel class="list-view-link" :data="arr.export" worksheet="Listado de movimientos de caja/cuenta" name="list-cash.xls"><AppIcon name="download" class="mr-1" /> Exportar</export-excel>
            </div>
      </b-card>

      <div ref="totalsAnchor" class="cash-detail-totals-anchor" v-if="table.items.length && filters.finances_cash"></div>

      <b-row align-h="end" v-if="table.items.length && filters.finances_cash && !totalsFloating" :key="'inline_'+keyForceUpdate">
        <b-col sm="4">      
          <b-card no-body class="cash-detail-totales">
            <b-table-simple hover responsive class="app-table m-0">
              <b-thead>
                <b-tr>                      
                  <b-th width="30%" class="text-right">
                    <div class="mr-1">Moneda</div>                        
                  </b-th>
                  <b-th width="35%" class="text-right">
                    <div class="mr-1">Total</div>
                  </b-th>                                
                  <b-th width="35%" class="text-right">
                    <div class="mr-1">Resumen</div>                        
                  </b-th>                                    
                </b-tr>
              </b-thead>  
              <b-tbody> 
                <b-tr v-for="(element, index) in this.getTotalByCurrency()" :key="'inline_'+index">                                       
                  <b-td class="text-right align-middle">        
                    <div class="mr-1">
                      <b>{{element.currency_name}}</b>
                    </div>            
                  </b-td>                  
                  <b-td class="text-right align-middle cash-detail-amount-totals">   
                    <div class="mr-1" v-if="filters.finances_cash" :class="{'cash-detail-text-danger':parseFloat(getTotalCash(element.currency_id))<0, 'cash-detail-text-success':parseFloat(getTotalCash(element.currency_id))>=0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( getTotalCash(element.currency_id) )}}
                    </div>            
                  </b-td>
                  <b-td class="text-right align-middle">        
                    <div class="mr-1 cash-detail-amount-totals" :class="{'cash-detail-text-danger':parseFloat(element.currency_amount)<0, 'cash-detail-text-success':parseFloat(element.currency_amount)>=0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( element.currency_amount )}}
                    </div>            
                  </b-td>                                    
                </b-tr>
              </b-tbody>
            </b-table-simple>            
          </b-card>
        </b-col>
      </b-row>

      <div class="cash-detail-totals-floating" v-if="table.items.length && filters.finances_cash && totalsFloating">
        <b-card no-body class="cash-detail-totales">
          <b-table-simple hover responsive class="app-table m-0">
            <b-thead>
              <b-tr>                      
                <b-th width="30%" class="text-right">
                  <div class="mr-1">Moneda</div>                        
                </b-th>
                <b-th width="35%" class="text-right">
                  <div class="mr-1">Total</div>
                </b-th>                                
                <b-th width="35%" class="text-right">
                  <div class="mr-1">Resumen</div>                        
                </b-th>                                    
              </b-tr>
            </b-thead>  
            <b-tbody> 
              <b-tr v-for="(element, index) in this.getTotalByCurrency()" :key="'fixed_'+index">                                       
                <b-td class="text-right align-middle">        
                  <div class="mr-1">
                    <b>{{element.currency_name}}</b>
                  </div>            
                </b-td>                  
                <b-td class="text-right align-middle cash-detail-amount-totals">   
                  <div class="mr-1" v-if="filters.finances_cash" :class="{'cash-detail-text-danger':parseFloat(getTotalCash(element.currency_id))<0, 'cash-detail-text-success':parseFloat(getTotalCash(element.currency_id))>=0}">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( getTotalCash(element.currency_id) )}}
                  </div>            
                </b-td>
                <b-td class="text-right align-middle">        
                  <div class="mr-1 cash-detail-amount-totals" :class="{'cash-detail-text-danger':parseFloat(element.currency_amount)<0, 'cash-detail-text-success':parseFloat(element.currency_amount)>=0}">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( element.currency_amount )}}
                  </div>            
                </b-td>                                    
              </b-tr>
            </b-tbody>
          </b-table-simple>            
        </b-card>
      </div>
      
      <b-card body-class="py-2" class="cash-detail-page-footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>
      
          <b-col>
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterReport()" />
            </nav>
          </b-col>  
        </b-row>
      </b-card>


      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <CashMovementFormModal ref="cashMovementForm"
                             @saved="onCashMovementSaved" />

      <b-modal v-model="modal.bankType.active" size="md" title="Tipo de movimiento" centered no-close-on-backdrop>
        <div v-if="modal.bankType.item">
          <div class="mb-2"><small>{{ modal.bankType.item.reference }}</small></div>
          <b-form-select size="sm" v-model="modal.bankType.value">
            <b-form-select-option :value="null">Sin tipo</b-form-select-option>
            <b-form-select-option v-for="type in bankTypeOptions(modal.bankType.item.type_balance)" :key="type.value" :value="type.value">{{ type.text }}{{ type.purchase ? ' (lleva comprobante)' : '' }}</b-form-select-option>
          </b-form-select>
        </div>
        <div slot="modal-footer">
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="modal.bankType.active = false">Cancelar</b-button>
          <b-button size="sm" variant="dark" @click="saveBankType()">Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Function from '@/handler/funciones'
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import FindObject from '@/components/inc/find/findObject' 
  import CashMovementFormModal from './inc/CashMovementFormModal'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      CashMovementFormModal,
      ModuleViewHeading,
      TabHeaderActions,
    }, 
    data: () => {
      return {      
        Modules,
        Profiles,
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'cashDetail',
          elements: {}
        }, 
        table : {
          items: [],
          filters: null,
          fields: [],
          currentPage: 1,
          perPage: 0,
          tablePaginate: null,
          isBusy: false,
        },          
        arr: {
          export: [],
          bankTypes: [],
        },
        selectedMovements: [],
        filters: {
          finances_cash: null,
          finances_cash_id: 0,
          finances_cash_transfer: null,
          finances_cash_transfer_id: 0,
          currency: null,
          currency_id: 0,
          staff: null,
          staff_id: 0,
          date_start: '',
          time_start: '',
          date_end: '',
          time_end: '',
        }, 
        modal: {
          bankType: { active: false, item: null, value: null },
        },         
        object: {
          staff: null
        },        
        keyForceUpdate: 0,   
        totalsFloating: false,
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    computed: {
      isBankCash() {
        return !!(this.filters.finances_cash && this.filters.finances_cash.kind == 'BANK' && this.filters.finances_cash.allow_purchase_link)
      },
      selectedTotalFormat() {
        var total = this.table.items.filter(item => this.selectedMovements.includes(item.id))
                                    .reduce((sum, item) => sum + parseFloat(item.amount), 0)
        return Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(total)
      },
      // WHERE SELECT
      conditionCurrencyActive(){
        let condition = []
        condition.push({field: 'status', condition: true})
        return condition
      },
      conditionCashOr() {        
        var arrWhere = []          
        if(this.object.staff && this.object.staff.cash_id) {
          arrWhere.push({field: 'id', condition: this.object.staff.cash_id})
          arrWhere.push({field: 'shared', condition: true})     
        } 
        return arrWhere;
      }, 
    },
    mounted() {      
      this.filtersOpen = Storage.getValue('filters_open_cash_detail') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.loadBankTypes()
      this.showStaff()
      window.addEventListener('scroll', this.refreshTotalsPosition, { passive: true })
      window.addEventListener('resize', this.refreshTotalsPosition)

      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.showStaff()
      window.addEventListener('scroll', this.refreshTotalsPosition, { passive: true })
      window.addEventListener('resize', this.refreshTotalsPosition)
      this.refreshTotalsPosition()
    },
    deactivated() {
      window.removeEventListener('scroll', this.refreshTotalsPosition)
      window.removeEventListener('resize', this.refreshTotalsPosition)
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      window.removeEventListener('scroll', this.refreshTotalsPosition)
      window.removeEventListener('resize', this.refreshTotalsPosition)
    },       
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_cash_detail', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Function.avatarFromName(name)
      },
      loadFieldTable() {
        this.table.fields = [
          {key: 'id', label: 'ID', class: 'align-middle', width:'5%'},
          {key: 'date', label: 'Fecha', class: 'align-middle', width:'9%'},
          {key: 'time', label: 'Hora', class: 'align-middle', width:'5%'},
          {key: 'reference', label: 'Referencia', class: 'align-middle cash-detail-cell-wrap', width:'22%'},
          {key: 'origen', label: 'Origen', class: 'align-middle cash-detail-cell-wrap', width:'13%'},
          {key: 'staff', label: 'Usuario', class: 'align-middle', width:'15%'},
          {key: 'observations', label: 'Observaciones', class: 'align-middle cash-detail-cell-wrap', width:'13%'},
          {key: 'amount', label: 'Importe', class: 'align-middle ' + this.alignClass('text-right'), width:'20%'},
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle', width:'2%'},
        ]
      },
      showStaff()  {
        let staffID = Helper.getStaffId()
        var result = serviceAPI.mostrarStaff(staffID)

        result.then((response) => {
          var data = response.data
          if(data) {
            this.object.staff = data
          } else {
            this.object.staff = null
          } 
          
          this.searchCash()
        })          
      },           
      searchCash() {                
        var result = serviceAPI.obtenerCajas()

        result.then((response) => {
          var data = response.data

          if(data.length) {     
            this.filters.finances_cash = data[0]
            this.filters.finances_cash_id = data[0].id
          }    

          this.filterLoad()      
          this.restoreFilterStorage() 

          this.forceUpdate()                    
          this.consumeQuickAction()
          //this.filterReport()          
        })                  
      },      
      filterLoad() { 
        this.filters.date_start = moment().format('YYYY-MM-DD')  
        this.filters.time_start = null  
        this.filters.date_end = moment().format('YYYY-MM-DD') 
        this.filters.time_end = null  
      },
      loadCash (object) {        
        if(object){
          this.filters.finances_cash = object
          this.filters.finances_cash_id = object.id    
          
          this.filterReport()
        } else {
          this.filters.finances_cash = null
          this.filters.finances_cash_id = 0
          this.table.items = []
          this.totalsFloating = false
        }
      }, 
      loadCurrency (object) {        
        if(object){
          this.filters.currency = object
          this.filters.currency_id = object.id        
        } else {
          this.filters.currency = null
          this.filters.currency_id = 0
        }
      }, 
      loadStaffFilter(object) {
        this.filters.staff = object || null
        this.filters.staff_id = object ? object.id : 0
      },
      filterReport(){
        this.selectedMovements = []
        this.saveFilterStorage()     

        if(!this.filters.finances_cash_id) {
          this.$awn.alert("Debe seleccionar una caja/cuenta");
          return false;
        }

        this.table.isBusy = true
        var result = serviceAPI.filtrarCajaDetalle(this.filters, this.table.currentPage)        

        result.then((response) => {
          this.table.isBusy = false
          this.table.items = response.data.data
          this.table.tablePaginate = response.data

          this.prepareExport(response.data.data)
          this.refreshTotalsPosition()
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      }, 
      refreshTotalsPosition() {
        this.$nextTick(() => {
          if(!this.table.items.length || !this.filters.finances_cash) {
            this.totalsFloating = false
            return
          }

          let anchor = this.$refs.totalsAnchor
          if(Array.isArray(anchor)) {
            anchor = anchor[0]
          }
          if(anchor && anchor.$el) {
            anchor = anchor.$el
          }

          if(!anchor || !anchor.getBoundingClientRect) {
            this.totalsFloating = false
            return
          }

          this.totalsFloating = anchor.getBoundingClientRect().top > (window.innerHeight - 20)
        })
      },

      getTotalByCurrency() {        
        var arrTotal = []

        if(this.table.items.length) {
          this.table.items.forEach(element=>{
            var code = element.currency.id     
            arrTotal[code] = null
            
            arrTotal[code] = {
              currency_id: element.currency.id,
              currency_name: element.currency.name,
              currency_code: element.currency.code,
              currency_amount: 0,
            }
          })          
        }
        
        this.table.items.forEach(element=>{                 
          var code = element.currency.id          

          if(element.type_balance == '+') {
            arrTotal[code].currency_amount = parseFloat(arrTotal[code].currency_amount) + parseFloat(element.amount)
          } else {
           arrTotal[code].currency_amount = parseFloat(arrTotal[code].currency_amount) - parseFloat(element.amount) 
          }          
        })

        arrTotal = arrTotal.filter((obj) => { return ![null, undefined].includes(obj) })

        return arrTotal        
      },
      getTotalCash($currency_id) {        
        var total = 0
        if(this.filters.finances_cash) {
          this.filters.finances_cash.total_available.forEach(element => {
            if(element.currency_id == $currency_id) {
              total = element.amount
            }            
          }); 
        }
        return total
      },

      forceUpdate() {
        this.keyForceUpdate = this.keyForceUpdate + 1
      },          

      goTo(data) {
        switch (data) {
          case 'positive-adjustment':
            this.addAdjustment('+')
            break;
        
          case 'negative-adjustment':
            this.addAdjustment('-')
            break;
            
          case 'transfer':
            this.addTransfer()
            break;                      
        }
      },
      consumeQuickAction() {
        if (this.$route.query.new != '1') return

        var mode = this.$route.query.mode
        if (mode == 'cash-income') this.addAdjustment('+', true)
        else if (mode == 'cash-expense') this.addAdjustment('-', true)
        else if (mode == 'cash-transfer') this.addTransfer(true)
        else return

        this.$router.replace({ name: 'FinancesStaffCashDetail' }).catch(() => {})
      },
      addAdjustment(type_balance, selectOrigin = false) {
        this.$refs.cashMovementForm.addAdjustment(type_balance, selectOrigin, this.filters.finances_cash_id, this.filters.finances_cash)
      },
      addTransfer(selectOrigin = false) {
        this.$refs.cashMovementForm.addTransfer(selectOrigin, this.filters.finances_cash_id, this.filters.finances_cash)
      },


      onCashMovementSaved() {
        this.forceUpdate()
        this.filterReport()
      },
      // TIPOS DE MOVIMIENTO BANCARIO (catálogo: FinancesCashDetail::BANK_TYPES)
      loadBankTypes() {
        serviceAPI.obtenerTiposMovimientoBancario().then((response) => {
          this.arr.bankTypes = response.data
        })
      },
      bankTypeName(code) {
        var type = this.arr.bankTypes.find(element => element.value == code)
        return type ? type.text : code
      },
      bankTypeOptions(typeBalance) {
        return this.arr.bankTypes.filter(element => !element.balance || element.balance == typeBalance)
      },
      // movimiento de una cuenta bancaria que no viene de un recibo, una OP ni una transferencia
      canSetBankType(item) {
        return this.isBankCash && !item.transfer_id && !item.is_cheque_movement && !(item.origen && (item.origen.supplier || item.origen.customer))
      },
      purchasePending(item) {
        return !!(item.purchase_link && item.purchase_link.status == 'PENDING')
      },
      openBankType(item) {
        this.modal.bankType.item = item
        this.modal.bankType.value = item.bank_type || null
        this.modal.bankType.active = true
      },
      saveBankType() {
        let loader = this.$loading.show()
        serviceAPI.definirTipoMovimiento(this.modal.bankType.item.id, this.modal.bankType.value)
        .then(() => {
          loader.hide()
          this.modal.bankType.active = false
          this.filterReport()
          this.$awn.success("Tipo de movimiento guardado")
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      // Compras arma el comprobante con estos movimientos y se paga con ellos: no hay débito nuevo
      loadPurchase() {
        var ids = this.selectedMovements.slice()
        let loader = this.$loading.show()
        serviceAPI.validarMovimientosParaComprobante(ids)
        .then(() => {
          loader.hide()
          this.selectedMovements = []
          this.$router.push({ name: 'PurchaseStaffPurchaseGenerateByBankMovements', params: { cashDetailIDs: ids.join(',') } }).catch(() => {})
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      remove(item) {        
        this.$bvModal.msgBoxConfirm('¿Desea borrar el ajuste (' + item.reference + ')?', {
          title: 'Borrar Ajuste',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCajaDetalle(item.id);

            result.then(() => {
              this.$refs.cashMovementForm.close()        
              loader.hide()

              this.forceUpdate()                    
              this.filterReport()

              this.$awn.success("Ajuste eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_cash_details', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {                        
        if(Storage.getValue('filter_cash_details')) {
          this.filters = JSON.parse(Storage.getValue('filter_cash_details'))
        }         

        let finances_cash_id = this.$route.params.finances_cash_id        
        let date_start = this.$route.params.date_start        
        if(finances_cash_id) {
          this.filters.finances_cash_id = finances_cash_id
          this.filters.date_start = moment(date_start).format('YYYY-MM-DD')
          this.filters.time_start = moment(date_start).format('HH:mm')          
          // al llegar por enlace, hasta hoy (el filtro guardado puede tener una fecha anterior)
          this.filters.date_end = moment().format('YYYY-MM-DD')
          this.filters.time_end = null
        }
      },    
      prepareExport(data) {        
        this.arr.export = []

        data.forEach(element => {
          var amount = element.amount
          
          if(element.type_balance == '-'){
              amount = element.type_balance + amount
          }

          this.arr.export.push({
            id: element.id,
            date: moment(element.date_time).format('YYYY-MM-DD'),
            time: moment(element.date_time).format('HH:mm'),
            reference: element.reference,
            origen: element.origen.customer ? "CLIENTE: " + element.origen.customer : element.origen.supplier ? "PROVEEDOR: " + element.origen.supplier : '',            
            staff: element.origen.staff || '',
            amount: amount.replace('.',','),
          })
        });        
      },

      statusCash(data) {
        let status = ''
        
        if(data.status.status == 'OPEN') {
          if(data.status.open) {
            status = moment(data.status.open).locale('es').fromNow()
          } else {
            status = moment().locale('es').fromNow()
          }
          
        }

        return status       
      }      
    }    
  }
</script>
<style>
  .cash-detail-filter-findobject .form-group { margin-bottom: 0; }
  .cash-detail-filter-findobject legend,
  .cash-detail-filter-findobject label { border: 0; color: var(--app-color-text-secondary); display: block; float: none; font-size: 11px; font-weight: var(--app-font-semibold); line-height: normal; margin-bottom: 2px; padding: 0; width: auto; }
  /* La tabla usa anchos fijos: estas tres columnas continúan en varias
     líneas al alcanzar su límite, en vez de truncarse. */
  .cash-detail-movimientos .app-table td.cash-detail-cell-wrap {
    overflow: visible !important;
    overflow-wrap: anywhere !important;
    text-overflow: clip !important;
    white-space: normal !important;
  }
  .cash-detail-movimientos .app-table td.cash-detail-cell-wrap > * {
    overflow-wrap: anywhere !important;
    white-space: normal !important;
  }
  @media (min-width: 768px) {
    /* Las filas sin menú de acciones conservan el alto mínimo de aquellas que
       sí contienen el botón de tres puntos; el contenido multilínea puede
       ampliar la fila normalmente. En mobile la tabla se apila y no se debe
       fijar el alto de la fila. */
    .cash-detail-movimientos .app-table tbody tr { height: 34px; }
  }
</style>
<style scoped>
  .cash-detail-amount-totals {
    font-size: 15px;
    color: var(--app-color-success);
    font-weight: 800;
  }
  .cash-detail-text-success {
    color: var(--app-color-success);
  }
  .cash-detail-text-danger {
    color: var(--app-color-danger);
  }
  .cash-detail-purchase { align-items: center; border: 1px solid; border-radius: 999px; display: inline-flex; font-size: var(--app-text-xs); gap: 4px; padding: 1px 8px; }
  .cash-detail-purchase--type { background: var(--app-color-surface-subtle); border-color: var(--app-color-border); color: var(--app-color-text-secondary); }
  .cash-detail-purchase-bar { align-items: center; background: var(--app-color-surface-subtle); border: 1px solid var(--app-color-border); border-radius: 7px; display: flex; flex-wrap: wrap; gap: 8px; justify-content: space-between; margin-bottom: 8px; padding: 8px 12px; }
  .cash-detail-purchase--pending { background: var(--app-color-warning-soft); border-color: var(--app-color-warning-border); color: var(--app-color-warning-hover); }
  .cash-detail-purchase--linked { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .cash-detail-origin-observations { color: var(--app-color-text-secondary); display: block; line-height: 1.35; margin-top: 3px; overflow-wrap: anywhere; }

  .cash-detail-filter-cash { flex: 1 1 250px; max-width: 320px; }
  .cash-detail-filter-currency { flex: 1 1 190px; max-width: 260px; }
  .cash-detail-filter-staff { flex: 1 1 220px; max-width: 280px; }
  .cash-detail-movement-item { align-items: center; color: var(--app-color-text); display: inline-flex; font-size: var(--app-text-sm); gap: 8px; }
  .cash-detail-movement-icon { align-items: center; border-radius: 50%; display: inline-flex; height: 22px; justify-content: center; width: 22px; }
  .cash-detail-movement-icon .material-symbols-rounded { font-size: 15px; }
  .cash-detail-movement-icon--positive { background: var(--app-color-success-soft); color: var(--app-color-success); }
  .cash-detail-movement-icon--negative { background: var(--app-color-danger-soft); color: var(--app-color-danger); }
  .cash-detail-movement-icon--transfer { background: var(--app-color-primary-soft); color: var(--app-color-primary); }
  .cash-detail-context { background: var(--app-color-surface); border-bottom: 1px solid var(--app-color-border); box-shadow: inset 3px 0 0 var(--app-color-text-muted); padding: 7px 12px; }
  .cash-detail-context__status { align-items: center; color: var(--app-color-text-secondary); display: flex; flex-wrap: wrap; font-size: var(--app-text-sm); gap: 10px; min-height: 31px; }
  .cash-detail-context__refresh { margin-left: auto; }
  .cash-detail-table-footer { padding-right: 12px; }
  .cash-detail-page-footer { background: var(--app-color-surface); border: 1px solid var(--app-color-border-strong); box-shadow: 0 -3px 12px rgba(7, 58, 78, 0.13), 0 6px 16px rgba(7, 58, 78, 0.11); }
  .btn.cash-detail-action-toggle-labeled { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); height: auto !important; justify-content: flex-start; min-height: 0; padding: 0 !important; width: auto !important; }
  .cash-detail-action-toggle-labeled.btn:hover,
  .cash-detail-action-toggle-labeled.btn:focus { color: var(--app-color-primary-hover); text-decoration: underline; }
  .cash-detail-totals-anchor {
    height: 0;
  }
  .cash-detail-totals-floating {
    position: fixed;
    right: 10px;
    bottom: 10px;
    width: 420px;
    max-width: calc(100vw - 20px);
    z-index: 1000;
  }
  .cash-detail-totals-floating .card {
    border: 1px solid var(--app-color-info-border);
    box-shadow: 0 12px 30px rgba(7, 58, 78, 0.26), 0 2px 7px rgba(7, 58, 78, 0.14);
    overflow: hidden;
  }
  .table-cash-status-open {
    align-items: center;
    color: var(--app-color-success);
    display: inline-flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    gap: 5px;
  }
  .table-cash-status-close {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    gap: 5px;
  }
  @media (max-width: 575.98px) {
    .cash-detail-context__refresh { margin-left: 0; }
  }
</style>
